import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";

export class AgGridAuditSettings {

  constructor(private translate: TranslateService) { }

    public agGridAuditSettings = {
    rowModelType: 'infinite',
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 55,
    enableRangeSelection: true,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 0,
    columnDefs: [
      { 
        field: 'action', 
        headerName: "Aktion", 
        sortable: true, 
        filter: true, 
        tooltipValueGetter: (params: any) => {
            // your logic here
            return this.getToolTip(params.value);
        },
        //        tooltipValueGetter: (params: ICellRendererParams) => this.getToolTip(_.get(params.data, 'action', ''))
      },
      { field: 'grouprolE_NAME', headerName: "Rolle", sortable: true, filter: true },
      { field: 'projecT_NAME', headerName: "Projekt", sortable: true, filter: true },
      { field: 'creatoR_NAME', headerName: "Erstellt von", sortable: true, filter: true },
      { 
        field: 'createD_WHEN', 
        headerName: "Erstellt am", 
        sortable: true, 
        filter: false,
        valueFormatter: (params: any) => {
          if (!params.value) return '';
          const date = new Date(params.value);
          return date.toLocaleDateString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
        }
      },
      { 
        field: 'useR_NAME', 
        headerName: "Benutzer", 
        sortable: true, 
        filter: true,
        tooltipField: 'useR_EMAIL' // Tooltip für das Feld Benutzer
      },
    //   { field: 'useR_EMAIL', headerName: "E-Mail", sortable: true, filter: true },
      { field: 'acT_PERMISSIONS', headerName: "Aktuelle Rechte", sortable: true, filter: true, tooltipField: 'acT_PERMISSIONS' }, // Tooltip für das Feld Aktuelle Rechte
      { field: 'preV_PERMISSIONS', headerName: "Vorherige Rechte", sortable: true, filter: true, tooltipField: 'preV_PERMISSIONS' }, // Tooltip für das Feld Vorherige Rechte
    //       type!: string;
    // action!: string;
    // groupRoleId!: string;
    // groupRoleName!: string;
    // projectId!: string;
    // projectName!: string;
    // creatorId!: string;
    // creatorName!: string;
    // createdWhen!: string; // ISO string
    // userId!: string;
    // userEmail!: string;
    // userName!: string;
    // actPermissions!: string;
    // prevPermissions!: string;

    //   {
    //     width: 430,
    //     headerName: `${this.translate.data["USERSACTIONSCOLUMNHEADER"]}`,
    //     cellRenderer: 'buttonRenderer',
    //     cellRendererParams: {
    //       // icon_edit: 'edit',
    //       // icon_view: 'visibility',
    //       icon_delete: 'delete',
    //       // routerLinkEditUser: (params: ICellRendererParams) => `/user-proflie/${_.get(params, 'data.id')}`,
    //     },
    //   },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }
  getToolTip(action: string): string {
    // const action = _.get(params.data, 'action', '');
    if (action === 'UpdTGR') {
      return 'Mandantengruppenrolle wurde geändert';
    } else if (action === 'RemFromTGR') {
      return 'Benutzer wurde aus der Mandantengruppenrolle entfernt';
    } else if (action === 'AssToTGR') {
      return 'Benutzer wurde zur Mandantengruppenrolle hinzugefügt';        
    } else if (action === 'UpdPGR') {
      return 'Projektgruppenrolle wurde geändert';
    } else if (action === 'RemFromPGR') {
      return 'Benutzer wurde aus der Projektgruppenrolle entfernt';         
    } else if (action === 'AssToPGR') {
      return 'Benutzer wurde zur Mandantengruppenrolle hinzugefügt';        
    } else return 'Unbekannte Aktion';
    //return `E-Mail: ${userEmail}`;
  }
}
